<template>
  <!-- main-footer -->
  <footer class="main-footer">
      <div class="pattern-layer">
          <div class="pattern-1" style="background-image: url(/assets/images/shape/shape-12.png);"></div>
          <div class="pattern-2" style="background-image: url(/assets/images/shape/shape-13.png);"></div>
          <div class="pattern-3" style="background-image: url(/assets/images/shape/shape-14.png);"></div>
      </div>
      <div class="auto-container">
          <div class="footer-top clearfix">
              <div class="line-shape" style="background-image: url(/assets/images/shape/shape-11.png);"></div>
              <div class="text pull-left">
                  <h2>Please <span>Call Us</span> to Take an Extraordinary Service</h2>
              </div>
              <div class="support-box pull-right">
                  <a href="tel:9726467383"><i class="fas fa-phone"></i>+91 97264 67383</a>
              </div>
          </div>
          <div class="widget-section">
              <div class="row clearfix">
                  <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
                      <div class="footer-widget logo-widget">
                          <figure class="footer-logo"><router-link to="/"><img src="/assets/images/logo/logo-5.png" alt="logo"></router-link></figure>
                          <div class="text text-center">
                              <p>Total Water and Environment Management Solutions.</p>
                          </div>
                          <!-- <div class="schedule-box">
                              <h6>Open Hours:</h6>
                              <ul class="list clearfix">
                                  <li>Mon - Sat: 9AM - 6PM.</li>
                                  <li>Sunday: Closed</li>
                              </ul>
                          </div> -->
                      </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
                      <div class="footer-widget contact-widget ml-70">
                          <div class="widget-title">
                              <h4>Address</h4>
                          </div>
                          <div class="widget-content">
                              <ul class="info-list clearfix">
                                  <li><i class="fal fa-map-marker-alt"></i>C-1401, Shilpan Prime, 80 feet Punit Nagar Road, Mavdi, Rajkot 360005</li>
                                  <li><i class="fal fa-phone"></i>Call Us: <a href="tel:9726467383">+(91) 97264 67383</a></li>
                                  <li><i class="fal fa-envelope-open-text"></i><a href="mailto:info@aksharwatertech.in">info@aksharwatertech.in</a></li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 footer-column">
                      <div class="footer-widget links-widget ml-70">
                          <div class="widget-title">
                              <h4>Usefull Link</h4>
                          </div>
                          <div class="widget-content">
                              <ul class="links-list clearfix">
                                  <li><router-link to="/about-us">About Company</router-link></li>
                                  <li><router-link to="/product">Products</router-link></li>
                                  <li><router-link to="/contact-us">Contact</router-link></li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <!-- <div class="col-lg-3 col-md-6 col-sm-12 footer-column">
                      <div class="footer-widget subscribe-widget">
                          <div class="widget-title">
                              <h4>Subscribe</h4>
                          </div>
                          <div class="widget-content">
                              <p>Lorem ipsum dolor sit amet, consect adipisicing elit sed do eiusmod.</p>
                              <div class="form-inner">
                                  <form action="contact.html" method="post">
                                      <div class="form-group">
                                          <input type="email" name="email" placeholder="Your Email" required="">
                                          <button type="submit"><i class="far fa-long-arrow-alt-right"></i></button>
                                      </div>
                                  </form>
                              </div>
                          </div>
                      </div>
                  </div> -->
              </div>
          </div>
      </div>
      <div class="footer-bottom">
          <div class="auto-container">
              <div class="bottom-inner">
                  <div class="copyright">
                      <p><router-link to="/">Akshar WaterTech</router-link> &copy; 2025 All Right Reserved</p>
                  </div>
                  <ul class="social-links clearfix">
                      <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>                      
                      <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                      <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                      <li><a href="https://g.co/kgs/zH7nNpc"><i class="fab fa-google"></i></a></li>
                  </ul>
                  <ul class="footer-nav clearfix">
                      <li><router-link to="/">Terms of Service</router-link></li>
                      <li><router-link to="/">Privacy Policy</router-link></li>
                  </ul>
              </div>
          </div>
      </div>
  </footer>
  <!-- main-footer end -->

  <div class="call-buttons-container">
    <a      
        href="tel:9726467383"    
        key="call_btn"
        class="call-btn-link"
        aria-label="Contact by phone"
        id="quick_call_btn"      
        role="button"
    >
      <i class="fas fa-phone"></i>
    </a> 
    <a      
      href="https://wa.me/9726467383?text=I%20want%20to%20know%20more%20about%20the%20products."
      key="call_btn"
      class="call-btn-link"
      aria-label="Contact by phone"
      id="quick_call_btn"      
      role="button"
    >
      <i class="fab fa-whatsapp font-x-large"></i>
    </a> 
    <a      
      href="https://g.co/kgs/zH7nNpc"
      key="g_review"
      class="call-btn-link"
      aria-label="Google Review"
      id="g_review"      
      role="button"
      target="_blank"
    >
      <i class="fab fa-google font-x-large"></i>
    </a> 
  </div>

    <!-- <div class="review-buttons-container">
        <a href="https://g.co/kgs/zH7nNpc" 
        target="_blank"
        class="review-btn-link"
        aria-label="Leave a review">
        <i class="fab fa-google"></i> <span class="review-text"></span>
        </a>
    </div> -->

  <!--Scroll to top-->
  <button class="scroll-top scroll-to-target" data-target="html">
      <span class="fal fa-angle-up"></span>
  </button>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
<style scoped>
/* .review-btn-link {
  color: white;
  text-decoration: none;
  transition: transform 0.3s;
}
.review-btn-link:hover {
  transform: scale(1.1);
}
.review-buttons-container {
  position: fixed;
  right: 0;
  top: 65%;
  padding: 10px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 25px 0 0 25px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
.review-btn-link {
  background: #f4b400;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.review-text { color: white; } */

.call-buttons-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 25px 0 0 25px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.call-btn-link, .whatsapp-btn-link {
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
}

.call-btn-link:hover, .whatsapp-btn-link:hover {
  transform: scale(1.1);
}

.call-btn-link { background: #00d1f9; }
.whatsapp-btn-link { background: #00d1f9; }

.font-x-large{
    font-size: x-large;
}
</style>